<template>
  <div v-if="stylist" class="col-md-4 col-sm-6 dashboard-item text-primary">
    <div class="card bg">
      <div class="row">
        <div class="col-12">
          <h2 class="text-white p-3">DASHBOARD</h2>
         <div>
            <div v-if="clients.length" class="text-primary m-3">
              <p>{{ message(content['dashboard.withClients'], stylist) }}</p>
            </div>
            <div v-else class="text-primary m-3">
              <p>{{ message(content['dashboard.noClients'], stylist) }}</p>
              <button class="btn btn-primary mt-4 container-fluid"><span>Add Clients</span></button>
            </div>
          </div>
          <overview-loading v-if="loadingDashboard" />
          <div class="item card-section" v-if="!loadingDashboard && dashboardData.commissions">
            <div class="card-section-container">
              <div class="card-section-item">
                <h4 class="text-white"><b>REPORTS</b></h4>
              </div>
              <div class="card-section-item text-right">
                <button class="btn btn-outline-light" @click="goToAction('commissions')">View Reports</button>
              </div>
            </div>
            <div class="card-section-container">
              <div class="card-section-item text-center">
                <h4 class="text-white">{{ currency(dashboardData.commissions[0].total) }}</h4>
                <p class="text-muted">Amount Received</p>
              </div>
              <div class="card-section-item text-center">
                <h4 class="text-white">{{ currency(dashboardData.commissions[0].pending) }}</h4>
                <p class="text-muted">Amount Pending </p>
              </div>
            </div>
          </div>
          <div class="item card-section" v-if="!loadingDashboard && dashboardData.pendingItems">
            <div class="card-section-container">
              <div class="card-section-item">
                <h4 class="text-white"><b>ACTIVITY</b></h4>
              </div>
              <div class="card-section-item text-right">
                <button class="btn btn-outline-light" @click="goToAction('notifications')">View Activity</button>
              </div>
            </div>
            <div class="card-section-container">
              <div class="card-section-item text-center">
                <h2 class="text-white">{{ taskCount }}</h2>
                <p class="text-muted">Open Tasks</p>
              </div>
              <div class="card-section-item text-center">
                <router-link :to="{ name: 'clients'}">
                  <h2 class="text-white">{{ dashboardData.pendingItems[0].pendingReviewTotal }}</h2>
                  <p class="text-muted">Quotes to Review</p>
                </router-link>
              </div>
              <div class="card-section-item text-center">
                <router-link :to="{ name: 'clients'}">
                  <h2 class="text-white">{{ dashboardData.pendingItems[0].pendingShipmentTotal }}</h2>
                  <p class="text-muted">Stuff to Ship</p>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api'
import OverviewLoading from './overview-loading'
export default {
  name: 'overview',
  data () {
    return {
      dashboardData: {},
      loadingDashboard: true
    }
  },
  components: { OverviewLoading },
  methods: {
    message (message, data) {
      return this.$helpers.dynamicContent(message, data)
    },
    currency (amount) {
      return this.$helpers.currency(amount)
    },
    goToAction (action) {
      if (action === 'commissions') {
        const element = document.getElementById(action)
        const elementPosition = element.getBoundingClientRect().top - 150
        return setTimeout(function () {
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          })
        }, 300)
      }
      this.$bvModal.show(action + '-modal')
    }
  },
  mounted () {
    api.get('/api/stylist/dashboard', {
      headers: {
        'Content-Type': 'application/x.fashionphile.v1+json, application/json'
      }
    }).then(response => {
      this.dashboardData = response.data
      this.loadingDashboard = false
      this.$emit('clicked', 'someValue')
    }).catch((error) => {
      return error
    })
  },
  computed: {
    stylist () {
      return this.$store.state.stylist
    },
    clients () {
      return this.$store.state.clients
    },
    content () {
      return this.$store.state.il8nContent
    },
    taskCount () {
      return this.$store.state.taskCount
    }
  }
}
</script>

<style>
  .card-section {
    margin: 15px;
    border-top: 1px solid #666;
    padding: 10px 0;
  }
  .card-section-container {
    display: flex;
    align-items: center;
    padding: 10px 0;
  }
  .card-section-item {
    flex: 1;
  }
</style>
